var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('mc-clicker',{attrs:{"data-testid":"count-clicker","mcLabel":_vm.testLabels.first,"count":_vm.testCount,"countType":"mealCountReceived","min":0}}),_c('mc-clicker',{attrs:{"data-testid":"temp-clicker","mcLabel":_vm.testLabels.second,"count":_vm.testCount,"countType":"mealDeliveryTemperature","min":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }